import React from 'react';
import TabsSection from '../../components/TabSection';

const Solutions1 = () => {
  const cardData = [
    {
      title: "ERP",
      image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359425/image_gfifhe.png",
    },
    {
      title: "OPPORTUNITIES",
      image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359391/image-1_bybda7.png",
    },
    {
      title: "RESOURCES",
      image: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745359425/image_gfifhe.png",
    },
  ];

  return (
    <div className="bg-white">
      <div className="md:px-28 px-4 md:pt-3 pt-2 md:pb-14 pb-4">
        <h1 className="text-[14px] md:text-[36px] font-bold md:mt-6 mt-2 md:mb-6 text-[#152C24]">FARMER</h1>
      
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745281649/image_lld8kj.png"
          alt="Securing Agriculture in Namibia"
          className="w-full md:h-[480px] object-cover md:rounded-lg rounded-md transition-opacity duration-500"
        />

        {/* Benefits Section Header */}

        {/* Benefits Cards */}
  
          <div  className="flex md:flex-row justify-between items-start md:mt-6 mt-2 gap-4">
            {/* Left Text Section */}
            <div className="flex-1">
  <section className="bg-white p-6">
    <h2 className="text-[32px] font-bold mb-6 text-[#152C24]">
      <strong className="font-bold text-black">FARMERS: </strong>
      What are the benefits?
    </h2>

    <h2 className="font-bold text-[32px] text-black mb-6">
      Farmnet App provides a variety of benefits to farmers, making it easier to manage their agricultural activities, access markets, and improve productivity. While features may vary slightly depending on the region or version, here are the key benefits most farmers can expect:
    </h2>

    <div className="space-y-6 text-[32px] text-[#152C24] mt-10">
      <div>
        <strong>1. Market Access</strong>
        <ul className="list-disc md;pl-16 mt-2 text-[32px] text-black">
          <li>Direct connections to buyers (retailers, wholesalers, exporters), helping farmers get better prices.</li>
          <li>Real-time market prices to avoid middlemen and sell produce competitively.</li>
        </ul>
      </div>

      <div>
        <strong>2. Farm Management Tools</strong>
        <ul className="list-disc md;pl-16 mt-2 text-[32px] text-black">
          <li>Digital record-keeping for planting, harvesting, input usage, and sales.</li>
          <li>Task scheduling and reminders for farm activities like irrigation, fertilization, and pest control.</li>
        </ul>
      </div>

      <div>
        <strong>3. Weather Forecasts</strong>
        <ul className="list-disc md;pl-16 mt-2 text-[32px] text-black">
          <li>Localized weather updates help plan irrigation, planting, and harvesting.</li>
          <li>Alerts for extreme weather events like drought, heavy rain, or frost.</li>
        </ul>
      </div>

      <div>
        <strong>4. Agricultural Advisory Services</strong>
        <ul className="list-disc md;pl-16 mt-2 text-[32px] text-black">
          <li>Tips on best farming practices, crop rotation, and sustainable agriculture.</li>
          <li>Disease and pest management support, sometimes with AI or expert assistance.</li>
        </ul>
      </div>

      <div>
        <strong>5. Financial Services</strong>
        <ul className="list-disc md;pl-16 mt-2 text-[32px] text-black">
          <li>Access to loans, microfinance, and insurance products.</li>
          <li>Digital payments and mobile banking integration to track income and expenses.</li>
        </ul>
      </div>

      <div>
        <strong>6. Community & Support</strong>
        <ul className="list-disc md;pl-16 mt-2 text-[32px] text-black">
          <li>A platform to connect with other farmers, cooperatives, or extension officers.</li>
          <li>Training materials, videos, and community forums.</li>
        </ul>
      </div>

      <div>
        <strong>7. Smart Farming Features (if available)</strong>
        <ul className="list-disc md;pl-16 mt-2 text-[32px] text-black">
          <li>Integration with drones, IoT devices, or satellite imagery for precision farming.</li>
          <li>Soil health analysis and recommendations.</li>
        </ul>
      </div>
    </div>
  </section>
</div>


     
          </div>
        
      </div>
    </div>
  );
};

export default Solutions1;
